import LazyLoad from "vanilla-lazyload";

window.LazyLoad = LazyLoad;

document.addEventListener("DOMContentLoaded", function () {
    window.globalLazyLoad = new LazyLoad();
})